"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDictateState;

var _WebChatReduxContext = require("../WebChatReduxContext"); // TODO: [P3] We should update this code to use core/src/selectors/dictateState.js


function useDictateState() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var dictateState = _ref.dictateState;
    return dictateState;
  })];
}